import { Divider, Form } from 'antd';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import ProductiveHoursSoldForm from '@/components/Reports/ProductiveReports/ProductiveHoursSoldForm';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { useReportGenerate } from '@/hooks';
import { ReportCallback } from '@/hooks/useReportGenerate';
import {
  ReportWorkOrderSoldHoursForm,
  ReportWorkOrderSoldHoursRequest,
} from '@/core/domain/NetReport/WorkOrder/WorkOrder.types';
import { DateTimeFormat } from '@/utils/moment';
import { useWorkOrderSoldHours } from '@/core/domain/NetReport/WorkOrder/WorkOrder.hook';

export default function ProductiveHoursSoldPage({ route }: PageProps) {
  const [form] = Form.useForm<ReportWorkOrderSoldHoursForm>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();
  const report = useReportGenerate();
  const generateReport = useWorkOrderSoldHours();
  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const {
        situation,
        type,
        initialDate,
        finalDate,
        companiesIds,
        ...values
      } = await form.validateFields();

      const obj: ReportWorkOrderSoldHoursRequest = {
        ...values,
        //-----------------Situation------------------
        open: situation.includes('open'),
        authorized: situation.includes('authorized'),
        closed: situation.includes('closed'),
        cancelled: situation.includes('canceled'),
        //--------------------Type--------------------
        showWorkOrder: type?.includes('budget') ?? false,
        showWarranty: type?.includes('warranty') ?? false,
        showReturn: type?.includes('return') ?? false,
        showCourtesy: type?.includes('courtesy') ?? false,
        showTotalLoss: type?.includes('totalLoss') ?? false,
        showRevision: type?.includes('revision') ?? false,
        //-------------------Others-------------------
        startDate: initialDate.format(DateTimeFormat),
        endDate: finalDate.format(DateTimeFormat),
        companiesIds: companiesIds ? companiesIds.toString() : '',
      };

      const result = await generateReport.mutateAsync(obj);
      if (callback) {
        callback(result);
      }
    } catch {}
    setFileUnloading(format);
  };
  const handleView = () => {
    handleGenerateReport('REPORT_VIEW', (result) =>
      report.openFile({
        result,
        fileName: 'horas_vendidas.pdf',
        fileType: 'application/pdf',
      }),
    );
  };
  const handlePdf = () => {
    handleGenerateReport('PDF', (result) =>
      report.downloadFile({
        result,
        fileName: 'horas_vendidas.pdf',
      }),
    );
  };

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <ProductiveHoursSoldForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
